module.exports = __webpack_public_path__ + "static/media/148.f2d0e91a.png";